import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { server, RECAPTCHA_KEY } from "../env";
import axios from "axios";
import Loader from "../components/Loader";
import Alert from "../components/Alert";
import Recaptcha from "react-google-invisible-recaptcha";

export default class Forgot extends PureComponent {
  state = { message: "", loader: "" };

  componentDidMount = () => {
    document.title = "Forgot Password - Proxies.gg";
  };

  forgot = async (e) => {
    e.preventDefault();
    this.setState({
      loader: <Loader />,
      message: "",
    });

    await this.recaptcha.execute();

    var params = Array.from(e.target.elements)
      .filter((el) => el.name)
      .reduce((a, b) => ({ ...a, [b.name]: b.value }), {});

    params["g-recaptcha-response"] = this.state.reCaptcha;

    localStorage.setItem("email", e.target.email.value);
    await axios
      .post(server + "/v1/auth/forgot-password", params)
      .then(async (rsp) => {
        this.setState({
          loader: "",
          message: <Alert className="success" message={rsp.data.detail} />,
        });
        this.props.history.push("change-password");
      })
      .catch((err) => {
        if (err.response) {
          this.setState({
            message: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          loader: "",
        });
      });
  };

  onResolved = () => {
    this.setState({ reCaptcha: this.recaptcha.getResponse() });
  };

  render() {
    const { message, loader } = this.state;

    return (
      <div className="col-12 col-md-5 col-xl-4 my-5">
        <h1 className="display-4 text-center mb-3">Forgot Password</h1>

        <p className="text-muted text-center mb-5">Forgot account password</p>

        <form onSubmit={this.forgot}>
          {message}
          <div className="form-group">
            <label className="form-label"> Email </label>

            <input
              type="email"
              className="form-control"
              placeholder="Enter email"
              name="email"
              autoFocus
              required
            />
          </div>

          <button type="submit" className="btn btn-lg w-100 btn-primary mb-3">
            Forgot Password {loader}
          </button>

          <div className="text-center">
            <small className="text-muted text-center">
              Remember Password? <Link to="/">Log In</Link>
            </small>
          </div>
        </form>
        <Recaptcha
          ref={(ref) => (this.recaptcha = ref)}
          sitekey={RECAPTCHA_KEY}
          onResolved={this.onResolved}
        />
      </div>
    );
  }
}
